import { TodoStatusOptions } from "enums/todos/todos.enum"

export default (status?: TodoStatusOptions) => {
    return {
        [TodoStatusOptions.DONE]: 'green',
        [TodoStatusOptions.IN_PROGRESS]: 'orange',
        [TodoStatusOptions.NOT_STARTED]: 'inherit',
        [TodoStatusOptions.STUCK]: 'red'
    }[status!]
}